import React, { useMemo } from "react";
import TextStage from "../stages/TextStage";
import useResponsiveStageAsset from "../../../hooks/useResponsiveStageAsset";
import StagePageLayout from "./StagePageLayout";

export default function RestaurantsStagePage({ stage, onDone, onSessionPointsChange }) {
  const bgAsset = useResponsiveStageAsset(stage.assets);
  const data = useMemo(() => ({ ...stage.data, background: bgAsset || stage.data.background }), [stage, bgAsset]);
  const pageStyle = useMemo(
    () =>
      bgAsset
        ? {
            backgroundImage: `url("${bgAsset}")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }
        : undefined,
    [bgAsset]
  );
  return (
    <StagePageLayout stageId={stage.id} theme={stage.theme} style={pageStyle}>
      <TextStage data={data} onDone={onDone} onSessionPointsChange={onSessionPointsChange} />
    </StagePageLayout>
  );
}
